// extracted by mini-css-extract-plugin
module.exports = {"icon":"GitHubIcon_icon__3ZXOr"};